/* eslint-disable */
document.addEventListener('scroll', () => {
	window.requestAnimationFrame(scrollTrackHandler);
}, { passive: true });

function scrollTrackHandler() {
	var h = document.documentElement,
		b = document.body,
		st = 'scrollTop',
		sh = 'scrollHeight';
	window.scrollPercent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

	if (window.scrollPercent >= 25) {
		UniqueScrollTrack('scroll-progress-25');
	}

	if (window.scrollPercent >= 50) {
		UniqueScrollTrack('scroll-progress-50');
	}

	if (window.scrollPercent >= 75) {
		UniqueScrollTrack('scroll-progress-75');
	}

	if (window.scrollPercent >= 99) {
		UniqueScrollTrack('scroll-progress-100');
	}
}

window.uniqueTrackNames = [];

function UniqueScrollTrack(text) {
	if (window.uniqueTrackNames.indexOf(text) == -1) {
		window.uniqueTrackNames.push(text);
		fireScrollTrack(text, text);
	}
}

function fireScrollTrack(text, customlink) {
	if(typeof s !== 'undefined') {
		s.events = 'event76';
		s.prop69 = text;
		s.eVar69 = 'D=c69';
		s.pageURL = window.location.href;
		s.tl(true, 'o', customlink);
		s.prop69 = s.eVar69 = s.events = '';
	}
}
